import {useDispatch} from "react-redux";
import {useEffect} from "react";
import {getMyMedia} from "../../store/reducers/my_media.reducer";
import {useMyMedia} from "./useMyMedia";
import { useKeycloak } from "@react-keycloak/web";

export const useGetMyMedia = () => {
	const { keycloak } = useKeycloak();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getMyMedia(keycloak.token));
	}, [dispatch]);

	const myMedia = useMyMedia();

	return myMedia;
}